import { SVGProps } from 'react';

export const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        {...props}
    >
        <g clipPath="url(#a)">
            <path
                fill="#fff"
                d="M12.256 4.697 16.97 9.41a.833.833 0 0 1 0 1.178l-4.714 4.714a.833.833 0 0 1-1.178-1.178l3.291-3.292H3.333a.833.833 0 1 1 0-1.666H14.37l-3.291-3.292a.834.834 0 1 1 1.178-1.178Z"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
        </defs>
    </svg>
);
